export const formatFCFA = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0 FCFA";
  return `${Math.round(Number(n)).toLocaleString("fr-FR").replace(/,/g, " ")} FCFA`;
};

export const formatNumber = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0";
  return Math.round(Number(n)).toLocaleString("fr-FR").replace(/,/g, " ");
};

export const ROLE_LABELS = {
  president: "Président",
  directeur_general: "Directeur Général",
  secretaire: "Secrétaire",
  entraineur: "Entraîneur",
  staff: "Staff",
};

export const PLAYER_POSITIONS = [
  "Gardien", "Défenseur central", "Latéral droit", "Latéral gauche",
  "Milieu défensif", "Milieu central", "Milieu offensif", "Ailier droit",
  "Ailier gauche", "Attaquant",
];

export const WEST_AFRICA_COUNTRIES = [
  "Bénin", "Burkina Faso", "Côte d'Ivoire", "Gambie", "Ghana",
  "Guinée", "Guinée-Bissau", "Libéria", "Mali", "Niger",
  "Nigeria", "Sénégal", "Sierra Leone", "Togo", "Cap-Vert",
];
